<template>
  <div class="module-info">
    <div class="map-contents">
      <div class="map-input">
        <input type="text" v-model="addrValue" id="map-input" />
        <div @click="searchGoogle()" v-if="isGoogle">
          <i class="el-icon-search"></i>
        </div>
        <div @click="getLocation()" v-else><i class="el-icon-search"></i></div>
      </div>
      <div id="platform-map"></div>
    </div>

    <!-- 基本信息 -->
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="auto"
      class="demo-ruleForm"
      size="small"
    >
      <el-form-item :label="$t('pages.operate.text25')">
        <div>
          {{ ruleForm.country }} {{ ruleForm.province }} {{ ruleForm.city }}
        </div>
      </el-form-item>
      <el-form-item :label="$t('pages.operate.text26')" prop="address">
        <el-input v-model="ruleForm.address"></el-input>
      </el-form-item>
      <div class="inputs">
        <el-form-item
          :label="$t('pages.operate.text27')"
          prop="platformAllName"
        >
          <el-input
            v-model="ruleForm.platformAllName"
            :placeholder="$t('pages.operate.text28')"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="platformShortName"
          label-width="0"
          style="margin-left: 20px"
        >
          <el-input
            v-model="ruleForm.platformShortName"
            :placeholder="$t('pages.operate.text29')"
            style="width: 120px"
          ></el-input>
        </el-form-item>
      </div>

      <el-form-item :label="$t('pages.operate.text30')">
        <DiluUploadImage
          accept=".jpg,.png"
          :limit="1"
          :fileList="fileList"
          @remove="removeimg"
          @success="success"
          :uploaDisabled="false"
        />
      </el-form-item>
      <div class="inputs">
        <el-form-item :label="$t('pages.operate.text31')" prop="contacts">
          <el-input
            v-model="ruleForm.contacts"
            :placeholder="$t('pages.operate.text31')"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="contactsMail"
          label-width="0"
          style="margin-left: 20px"
        >
          <el-input
            v-model="ruleForm.contactsMail"
            :placeholder="$t('pages.operate.text32')"
            style="width: 220px"
          ></el-input>
        </el-form-item>
      </div>
      <el-form-item :label="$t('pages.operate.text33')" prop="platformDomain">
        <el-input
          v-model="ruleForm.platformDomain"
          :placeholder="$t('pages.operate.text33')"
          autocomplete="new-password"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('pages.operate.text34')" prop="adminUsername">
        <el-input
          v-model="ruleForm.adminUsername"
          placeholder="admin"
          autocomplete="new-password"
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('pages.operate.text35')" prop="adminPassword">
        <el-input
          v-model="ruleForm.adminPassword"
          show-password
          autocomplete="new-password"
        >
          <template slot="append"
            ><el-button @click="randomString">{{
              $t("button.autoGeneration")
            }}</el-button></template
          >
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('pages.operate.text2')" prop="status">
        <el-radio-group v-model="ruleForm.status">
          <el-radio :label="0">{{ $t("pages.operate.text4") }}</el-radio>
          <el-radio :label="1">{{ $t("pages.operate.text5") }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="$t('pages.operate.text36')" prop="remark">
        <el-input
          v-model="ruleForm.remark"
          type="textarea"
          :rows="4"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="info-button">
      <DiluButton type="next" @click="next"></DiluButton>
    </div>
  </div>
</template>


<script>
import DiluButton from "../../../../components/pubilc/dilu-button.vue";
import DiluUploadImage from "../../../../components/pubilc/dilu-uploadimages.vue";
import {
  validatName,
  validatEmailAddress,
  validatDescribe,
  validatePassword,
} from "../../../../utils/util/test";
import { randomString } from "../../../../utils/util/validate";
import { mapState } from "vuex";
import remoteLoad from "@/assets/js/remoteLoad.js";

export default {
  data() {
    return {
      isGoogle: false,
      addrValue: "", //地图搜索
      marker: null,
      map: null,
      center: [116.397428, 39.90923],

      fileList: [],
      props: {
        value: "Name",
        label: "Name",
        children: "ChildList",
      },
      options: require("../../../../utils/util/addr.json"),
      ruleForm: {
        location: "",
        regionList: [], //自定义字段
        address: "", // 详细地址
        city: "", // 城市
        country: "", //国家
        province: "", //省份
        platformShortName: "", //平台方简称
        platformAllName: "", //平台方全称
        platformInfoImg: {
          //营业执照图片的名称和链接json
          imageName: "",
          imagePath: "",
        },
        contacts: "", //联系人
        contactsMail: "", //联系人邮箱
        platformDomain: null, //平台域名
        adminPassword: "", //admin登录密码
        adminUsername: "admin", // 	账号
        status: null, //状态 0启用 1禁用
        remark: "", //备注
      },
      addr: "", //地址
      rules: {
        regionList: [
          {
            required: true,
            message: this.$t("pages.operate.text37"),
            trigger: "blur",
          },
        ],
        address: [
          {
            required: true,
            message: this.$t("pages.operate.text38"),
            trigger: "blur",
          },
          {
            max: 256,
            message: this.$t("pages.equipment.text173"),
            trigger: "blur",
          },
        ],
        adminPassword: { validator: validatePassword, trigger: "blur" },
        platformAllName: [
          {
            required: true,
            message: this.$t("pages.operate.text39"),
            trigger: "blur",
          },
          {
            max: 30,
            message: this.$t("pages.operate.text40"),
            trigger: "blur",
          },
        ],
        platformShortName: [
          {
            required: true,
            message: this.$t("pages.operate.text41"),
            trigger: "blur",
          },
          {
            max: 10,
            message: this.$t("pages.operate.text42"),
            trigger: "blur",
          },
        ],
        contacts: [{ validator: validatName, trigger: "blur" }],
        contactsMail: [{ validator: validatEmailAddress, trigger: "blur" }],
        platformDomain: {
          required: true,
          message: this.$t("pages.operate.text43"),
          trigger: "blur",
        },
        remark: [{ validator: validatDescribe, trigger: "blur" }],
        status: {
          required: true,
          message: this.$t("pages.operate.text44"),
          trigger: "blur",
        },
      },
    };
  },
  watch: {
    activeName(newValue) {
      if (newValue == "EssentialInformation") {
        this.ruleForm = {
          regionList: [
            this.params.country,
            this.params.province,
            this.params.city,
          ], //自定义字段
          location: this.params.location,
          address: this.params.address, // 详细地址
          city: this.params.city, // 城市
          country: this.params.country, //国家
          province: this.params.province, //省份
          platformShortName: this.params.platformShortName, //平台方简称
          platformAllName: this.params.platformAllName, //平台方全称
          platformInfoImg: this.params.platformInfoImg, //营业执照图片的名称和链接json
          contacts: this.params.contacts, //联系人
          contactsMail: this.params.contactsMail, //联系人邮箱
          platformDomain: this.params.platformDomain, //平台域名
          adminPassword: this.params.adminPassword, //admin登录密码
          adminUsername: this.params.adminUsername, // 	账号
          status: this.params.status, //状态 0启用 1禁用
          remark: this.params.remark, //备注
        };
        // console.log(this.ruleForm)
        if (this.params.location) {
          // this.initMap();
          let regionList = this.regionList;

          if (regionList[this.currentRegion].id != "cn") {
            if (window.google) {
              this.initMap();
              // 未载入谷歌地图API，则先载入API再初始化
            } else {
              // 载入谷歌地图和UI组件
              Promise.all([
                remoteLoad(
                  "https://maps.googleapis.com/maps/api/js?key=AIzaSyByfqxMers4lp-sXvkU4P8dX4i6yQ3RZ84&libraries=visualization,places,geometry&language=en-us&region=EG"
                ),
              ]).then(() => {
                this.initMap();
              });
            }
          } else {
            if (window.AMap && window.AMapUI) {
              this.initMap();
              // 未载入高德地图API，则先载入API再初始化
            } else {
              // 载入高德地图和UI组件
              Promise.all([
                remoteLoad(
                  "https://webapi.amap.com/maps?v=1.4.15&key=77faf27c291ef4d7a20bfb8d5f74b0b4&plugin=AMap.Riding"
                ),
              ]).then(() => {
                this.initMap();
              });
            }
          }
          let addrArr = this.params.location.split(",");
          let arr = this.regionList;
          if (arr[this.currentRegion].id != "cn") {
            let addr = { lat: Number(addrArr[0]), lng: Number(addrArr[1]) };
            this.setGoogleMarker(addr);
            this.map.setCenter(addr);
          } else {
            this.setMarker({
              lat: Number(addrArr[0]),
              lng: Number(addrArr[1]),
            });
          }
        } else {
          // this.initMap();
          let regionList = this.regionList;

          if (regionList[this.currentRegion].id != "cn") {
            if (window.google) {
              this.initMap();
              // 未载入谷歌地图API，则先载入API再初始化
            } else {
              // 载入谷歌地图和UI组件
              Promise.all([
                remoteLoad(
                  "https://maps.googleapis.com/maps/api/js?key=AIzaSyByfqxMers4lp-sXvkU4P8dX4i6yQ3RZ84&libraries=visualization,places,geometry&language=en-us&region=EG"
                ),
              ]).then(() => {
                this.initMap();
              });
            }
          } else {
            if (window.AMap && window.AMapUI) {
              this.initMap();
              // 未载入高德地图API，则先载入API再初始化
            } else {
              // 载入高德地图和UI组件
              Promise.all([
                remoteLoad(
                  "https://webapi.amap.com/maps?v=1.4.15&key=77faf27c291ef4d7a20bfb8d5f74b0b4&plugin=AMap.Riding"
                ),
              ]).then(() => {
                this.initMap();
              });
            }
          }
        }
        if (this.params.platformInfoImg.imagePath) {
          if (this.fileList.length > 0) {
            return;
          }
          this.fileList = [
            {
              name: this.params.platformInfoImg.imageName,
              url: this.params.platformInfoImg.imagePath,
            },
          ];
        }
      }
    },
  },
  computed: {
    ...mapState(["regionList", "currentRegion"]),
  },
  props: ["activeName", "params", "pageState"],
  components: {
    DiluUploadImage,
    DiluButton,
  },
  mounted() {
    // setTimeout(() => {
    //   this.initMap();
    // }, 1000);
  },
  methods: {
    //初始化地图
    initMap() {
      let arr = this.regionList;
      if (arr[this.currentRegion].id != "cn") {
        this.initGoogleMap();
        this.isGoogle = true;
      } else {
        this.initCnMap();
        this.isGoogle = false;
      }
    },
    //初始化谷歌地图
    initGoogleMap() {
      let that = this;
      that.map = new google.maps.Map(document.getElementById("platform-map"), {
        center: { lat: -34.397, lng: 150.644 },
        mapId: "1dac188ecae44d48",
        zoom: 8,
        mapTypeControl: false,
        disableDefaultUI: true,
      });
      that.map.addListener("click", (mapsMouseEvent) => {
        that.setGoogleMarker({
          lat: mapsMouseEvent.latLng.lat(),
          lng: mapsMouseEvent.latLng.lng(),
        });
      });
    },
    //设置谷歌地图点
    setGoogleMarker(e) {
      // console.log(e);
      let that = this;
      if (that.marker) {
        that.marker.setMap(null);
      }
      that.marker = new google.maps.Marker({
        position: e,
        map: that.map,
      });
      this.ruleForm.location = "" + e.lat + "," + e.lng;
      this.getGoogleAddress(e);
    },
    //谷歌地图搜索服务
    searchGoogle() {
      let that = this;
      const request = {
        query: that.addrValue,
        fields: ["name", "geometry"],
      };

      let service = new google.maps.places.PlacesService(that.map);
      service.findPlaceFromQuery(request, (results, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK && results) {
          that.map.setCenter(results[0].geometry.location);
          that.setGoogleMarker({
            lat: results[0].geometry.location.lat(),
            lng: results[0].geometry.location.lng(),
          });
        }
      });
    },
    //谷歌地图地理编码
    getGoogleAddress(e) {
      let that = this;
      const geocoder = new google.maps.Geocoder();
      geocoder
        .geocode({ location: e })
        .then((response) => {
          if (response.results[0]) {
            let arr = response.results[1].address_components;
            for (let i in arr) {
              for (let j in arr[i].types) {
                if (arr[i].types[j] == "country") {
                  that.ruleForm.country = arr[i].long_name; // 国家
                }
                if (arr[i].types[j] == "administrative_area_level_1") {
                  that.ruleForm.province = arr[i].long_name; // 一级行政区
                }
                if (
                  arr[i].types[j] == "administrative_area_level_2" ||
                  arr[i].types[j] == "locality"
                ) {
                  that.ruleForm.city = arr[i].long_name; // 二级行政区
                }
              }
            }
          } else {
            window.alert("No results found");
          }
        })
        .catch((e) => window.alert("Geocoder failed due to: " + e));
    },
    //初始化高德地图
    initCnMap() {
      let that = this;
      this.map = new AMap.Map("platform-map", {
        mapStyle: "amap://styles/398469a1eaea0a930c1cb33226ee3080", //设置地图的显示样式
        zoom: 5,
        resizeEnable: true,
      });
      //为地图注册click事件获取鼠标点击出的经纬度坐标
      this.map.on("click", function (e) {
        that.setMarker({ lng: e.lnglat.getLng(), lat: e.lnglat.getLat() });
      });
    },
    //高德地图设置点
    setMarker(e) {
      let that = this;
      if (that.marker) {
        that.marker.setMap(null);
        that.marker = null;
      }
      that.marker = new AMap.Marker({
        icon: "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
        position: [e.lng, e.lat],
      });
      that.marker.setMap(that.map);
      that.map.setCenter([e.lng, e.lat]);
      that.getAddress([e.lng, e.lat]);
      this.ruleForm.location = "" + e.lat + "," + e.lng;
    },
    //高德搜索位置
    getLocation() {
      let that = this;
      AMap.service(["AMap.PlaceSearch"], function () {
        var placeSearch = new AMap.PlaceSearch();
        placeSearch.search(that.addrValue, function (status, result) {
          if (status == "complete" && result.info == "OK") {
            that.setMarker({
              lng: result.poiList.pois[0].location.lng,
              lat: result.poiList.pois[0].location.lat,
            });
            that.addrValue = "";
          } else {
            that.$message({
              message: this.$t("pages.operate.text45"),
              type: "warning",
            });
          }
        });
      });
    },
    //逆向地理编码
    getAddress(e) {
      let that = this;
      AMap.plugin("AMap.Geocoder", function () {
        var geocoder = new AMap.Geocoder();
        geocoder.getAddress(e, function (status, result) {
          if (status === "complete" && result.info === "OK") {
            // result为对应的地理位置详细信息
            that.ruleForm.country = result.regeocode.addressComponent.country;
            that.ruleForm.province = result.regeocode.addressComponent.province;
            that.ruleForm.city = result.regeocode.addressComponent.city;
          } else {
            that.$message({
              message: this.$t("pages.operate.text46"),
              type: "warning",
            });
          }
        });
      });
    },

    //自动生成密码
    randomString() {
      this.ruleForm.adminPassword = randomString(6);
    },
    //删除图片
    removeimg(e) {
      const i = this.fileList.findIndex((x) => x.name == e);
      this.fileList.splice(i, 1);
      this.ruleForm.platformInfoImg.imagePath = null;
      this.ruleForm.platformInfoImg.imageName = null;
    },
    //上传成功
    success(e) {
      this.ruleForm.platformInfoImg.imagePath = e.url;
      this.ruleForm.platformInfoImg.imageName = e.name;
      this.fileList = e.fileList;
    },
    next() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (!this.ruleForm.platformInfoImg.imagePath) {
            return this.$message.error(this.$t("pages.operate.text47"));
          }
          if (this.ruleForm.country && this.ruleForm.province) {
            this.$emit("essentialInfor", this.ruleForm);
          } else {
            return this.$message.error(this.$t("pages.operate.text48"));
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.inputs {
  width: 100%;
  display: flex;
  margin-bottom: 16px;
}
.module-info {
  padding: 20px;
  box-sizing: border-box;
}
.info-button {
  margin: 40px 0;
  display: flex;
  justify-content: center;
}
#platform-map {
  width: 100%;
  height: 350px;
  margin-bottom: 20px;
}
.map-contents {
  position: relative;
}
.map-input {
  width: 260px;
  height: 46px;
  background-color: #fff;
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: 22;
  border-radius: 8px;
  box-shadow: 0 2px 6px 0 rgb(114 124 245 / 50%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 10px;
  box-sizing: border-box;
}
.map-input input {
  flex: 1;
  border: none;
  outline: none;
  background-color: transparent;
}
.map-input div {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 10px;
  box-sizing: border-box;
  height: 100%;
  border-left: 1px solid #dfdfdf;
  cursor: pointer;
}
.map-input div i {
  font-size: 24px;
}
</style>